import { collection, getDocs } from "firebase/firestore";
import { ATTENDANCE_BRANCHES } from "../config/attendanceBranches";
import { db } from "../firebase";
import { resolveCollectionName } from "../services/attendanceCollections";

/** Billing branch → same employee Firestore group as payroll / holidays. */
export const BILLING_BRANCH_TO_ATTENDANCE_INDEX = { Main: 0, "Branch 2": 1, "Branch 3": 2 };

/** Resolve display name from Firestore doc (same field order as HolidaysPage). */
export function employeeRecordFromDoc(docSnap) {
  const d = docSnap.data() || {};
  const employeeId = String(
    d.employeeId ?? d.empId ?? d.user_id ?? d.userId ?? d.EmployeeId ?? docSnap.id ?? ""
  ).trim();
  const id = employeeId || docSnap.id;
  const employeeName = String(
    d.EmployeeName ?? d.employeeName ?? d.fullName ?? d.name ?? d.Name ?? id
  ).trim();
  const phone = String(d.phone ?? d.mobile ?? d.Mobile ?? "").trim();
  return { employeeId: id, employeeName: employeeName || id, phone };
}

/** Load deduplicated employees for a billing branch (Main, Branch 2, Branch 3). */
export async function loadEmployeesForBillingBranch(branchFilter) {
  const idx = BILLING_BRANCH_TO_ATTENDANCE_INDEX[branchFilter] ?? 0;
  const branchCfg = ATTENDANCE_BRANCHES[idx] || ATTENDANCE_BRANCHES[0];
  const colName = await resolveCollectionName(branchCfg.employeeCandidates || []);
  if (!colName) throw new Error("Employee collection not found for this branch.");
  const snap = await getDocs(collection(db, colName));
  const merged = new Map();
  for (const docSnap of snap.docs) {
    const rec = employeeRecordFromDoc(docSnap);
    if (!rec.employeeId) continue;
    const key = rec.employeeId.toLowerCase();
    if (!merged.has(key)) merged.set(key, rec);
  }
  return [...merged.values()].sort((a, b) => a.employeeName.localeCompare(b.employeeName));
}
